import React, { FC, useState } from "react";
import styled from "@emotion/styled";
import { TextField } from "@radix-ui/themes";
import { Button } from "@/components/button";

interface SearchFormProps {
  initialQuery?: string;
  initialSpaceId?: string;
  onSearch: (query: string, spaceId: string) => void;
}

export const WebClipsSearchForm: FC<SearchFormProps> = ({
  initialQuery = "",
  initialSpaceId = "",
  onSearch,
}) => {
  const [query, setQuery] = useState<string>(initialQuery);
  const [spaceId, setSpaceId] = useState<string>(initialSpaceId);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSearch(query.trim(), spaceId.trim());
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <TextFieldContainer
        placeholder="Search text..."
        value={query}
        onChange={event => setQuery(event.currentTarget.value)}
        style={{ flex: 1 }}
      />
      <TextFieldContainer
        placeholder="Space Account ID"
        value={spaceId}
        onChange={event => setSpaceId(event.currentTarget.value)}
        style={{ flex: 1 }}
      />
      <Button type="submit">Search</Button>
    </FormContainer>
  );
};

const FormContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const TextFieldContainer = styled(TextField.Root)`
  max-width: 360px;
`;
